import { useQuery } from '@tanstack/react-query'

import { apiV1 } from '@/shared/api/apiPrefix'
import { httpClient } from '@/shared/lib/httpClient'
import {
  unifiedSearchResponseSchema,
  type UnifiedSearchHit,
} from '@/shared/schemas/unifiedSearch.schema'

export const unifiedSearchKeys = {
  all: ['unified-search'] as const,
  query: (q: string) => ['unified-search', q] as const,
}

export async function fetchUnifiedSearch(q: string): Promise<UnifiedSearchHit[]> {
  const sp = new URLSearchParams({ q })
  const res = await httpClient.get<unknown>(apiV1(`/search?${sp.toString()}`))
  return unifiedSearchResponseSchema.parse(res.data).data
}

/** Debounced search is owned by the caller; this hook fetches when `q` is non-empty and enabled. */
export function useUnifiedSearch(q: string, enabled: boolean) {
  const trimmed = q.trim()

  return useQuery({
    queryKey: unifiedSearchKeys.query(trimmed),
    queryFn: () => fetchUnifiedSearch(trimmed),
    enabled: enabled && trimmed.length >= 1,
    staleTime: 30_000,
  })
}
